import { Navigate } from "react-router-dom";
import {
  getPortalSession,
  isPortalSessionExpired,
  clearPortalSession,
} from "../utils/portalAuth";

export default function PortalProtectedRoute({ children, type }) {
  const session = getPortalSession();

  if (!session.token || !session.user) {
    return <Navigate to="/portal/login" replace />;
  }

  if (isPortalSessionExpired()) {
    clearPortalSession();
    return <Navigate to="/portal/login" replace />;
  }

  if (type && session.userType !== type) {
    return <Navigate to="/portal/login" replace />;
  }

  return children;
}